export const DummyCreateSessionResponse = {
  accessToken: "xxxxxx",
};
